import { Job, SupabaseJob } from '@applicator/shared'

import { fetchJobsFromSupabase } from '../data'

import { processLoadedJobs } from './helpers'

// Helper function to initialize loading state
export function initializeLoadingState(
  isFirstLoad: boolean,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setError: React.Dispatch<React.SetStateAction<string | null>>,
  setDisplayedJobsCount: React.Dispatch<React.SetStateAction<number>>,
  setAllJobsLoaded: React.Dispatch<React.SetStateAction<boolean>>
) {
  if (!isFirstLoad) {
    setLoading(true)
  }
  setError(null)
  setDisplayedJobsCount(20)
  setAllJobsLoaded(false)
}

// Helper function to load jobs successfully
export async function loadJobsSuccessfully(
  loadingTimeout: NodeJS.Timeout,
  setJobs: React.Dispatch<React.SetStateAction<Job[]>>,
  setSupabaseJobs: React.Dispatch<React.SetStateAction<SupabaseJob[]>>,
  setAllJobsLoaded: React.Dispatch<React.SetStateAction<boolean>>,
  setSelectedJobFromMapped: (mappedJobs: Job[]) => void
) {
  const supabaseJobsData = await fetchJobsFromSupabase()
  clearTimeout(loadingTimeout)
  processLoadedJobs(
    supabaseJobsData,
    setJobs,
    setSupabaseJobs,
    setAllJobsLoaded,
    setSelectedJobFromMapped
  )
}

// Helper function to handle loading error
export function handleLoadingError(
  err: unknown,
  loadingTimeout: NodeJS.Timeout,
  setError: React.Dispatch<React.SetStateAction<string | null>>
) {
  clearTimeout(loadingTimeout)
  const errorMessage = err instanceof Error ? err.message : String(err)
  console.error('[JobDetail] Error loading jobs:', errorMessage)
  setError(errorMessage || 'Failed to load jobs')
}
